module.exports = __webpack_public_path__ + "img/Logo_Udalba.94e1bcaf.png";